import './pinCardView.scss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Component } from 'react';
import { FormattedText, formatText } from 'core/i18n';
import { actions as formActions } from 'react-redux-form';
import configCardActions from 'actions/configCardActions';
import { InputText } from 'components/inputText/inputText';
import classNames from 'classnames';
import cardImagesActions from 'actions/cardImagesActions';
import debitCardActions from 'actions/debitCardActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import { checkPinCard } from './helper/pinCardHelper';
import stepsActions from 'actions/stepsActions';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { Header } from 'components/header/header';
import Headline from 'components/headline';
import { InfoTooltip } from 'components/tooltip/tooltip';
import { recordEvent, PAGE_PRODUCT } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import cryptoJS from 'crypto-js';
import { PATH_SELECT_CARD, PATH_PIN_CARD } from 'constants/uTagConstants/paths';
import { DEBIT_CARD } from 'constants/statusProcess';

class PinCardView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            iconPass: 'icon-pass-on show-password',
            inputType: 'password',
            isOnEye: false,
            pinCard: '',
            showPassReq: false,
            showShakeAnimationOnPasswordError: false,
            passAscDesc: true,
            passEquals: true,
            passBirthYear: true,
            passValid: false,
            passSamePassword: true,
            showContinueBar: true,
            visiblePassword: false,
        };
    }

    componentDidMount() {
        const { userProfile, products, recordAndSavePage } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        recordAndSavePage(
            PATH_PIN_CARD,
            userProfile.recordId,
            userProfile.userId,
            userProfile.product,
            products.get('productsDescription'),
            userProfile.promoCode ? userProfile.promoCode : '',
            JointHolderInfo,
            '',
            '',
            userProfile.investmentType,
            {
                identificadorOnboarding: docNumberEncrypted,
            }
        );
        window.scrollTo(0, 0);
    }

    buildHeader = () => {
        // eslint-disable-line
        return <Header steps={false} />;
    };

    buildHeadLine = () => {
        // eslint-disable-line
        return (
            <Headline icon="tarjeta" className="card-selector-view__content__headline">
                <h3>
                    <FormattedText value="initialPinCard-headerTitle" />
                </h3>
                <p>
                    <FormattedText value="initialPinCard-headerDescription" />
                </p>
            </Headline>
        );
    };

    onHandleContinueButton = () => {
        const { cardImages, debitCardActions } = this.props;

        const payload = {
            standard: cardImages.get('cardStandardSelected'),
            subtype: cardImages.get('cardSubTypeSelected'),
            type: cardImages.get('cardTypeSelected'),
            pin: this.state.pinCard,
        };

        debitCardActions.selectPinDebitCard(payload);
    };

    handleChangePin = event => {
        this.setState({
            pinCard: event.target.value,
        });
    };

    backCardImageSelector = () => {
        const { formActions } = this.props;
        formActions.change('userProfile.status', DEBIT_CARD);
    };

    handleShowPassReq = show => {
        this.setState({
            showPassReq: show,
        });
    };

    handlePassword = () => {
        const visiblePassword = this.state.visiblePassword;
        if (visiblePassword) {
            this.handleHidePassword();
        } else {
            this.handleShowPassword();
        }
        this.setState({
            visiblePassword: !visiblePassword,
        });
    };

    handleShowPassword() {
        this.setState({
            inputType: 'tel',
            iconPass: 'icon-pass-off show-password-off',
        });
    }

    handleHidePassword() {
        this.setState({
            inputType: 'password',
            iconPass: 'icon-pass-on show-password',
        });
    }

    handleIsOnEye() {
        this.setState({
            isOnEye: true,
        });
    }

    handleIsOutEye() {
        this.setState({
            isOnEye: false,
        });
    }

    savePinCard = pinCard => {
        this.setState({
            pinCard,
        });
    };

    handleAllValidators = () => {
        this.setState({
            passValid: false,
            passAscDesc: true,
            passEquals: true,
            passBirthYear: true,
            passSamePassword: true,
        });
    };

    getCreatePinError = () => {
        const { passAscDesc, passEquals, passBirthYear, passSamePassword } = this.state;

        return [
            ...(!passAscDesc ? 'passAscDesc' : []),
            ...(!passEquals ? 'passEquals' : []),
            ...(!passBirthYear ? 'passBirthYear' : []),
            ...(!passSamePassword ? 'passSamePassword' : []),
        ]
            .map(validation => formatText(`field-${validation}`))
            .join(',');
    };

    checkPassword(value) {
        const {
            userProfile,
            userProfile: { docNumber },
        } = this.props;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        checkPinCard(userProfile.accessToken, value, (valid, typePinError) => {
            if (!valid) {
                this.setState(
                    {
                        showShakeAnimationOnPasswordError: !valid,
                        passAscDesc: !(typePinError === 0 || typePinError === 1),
                        passEquals: typePinError !== 2,
                        passBirthYear: !(typePinError === 3 || typePinError === 4),
                        passValid: valid,
                        showPassReq: !valid,
                        passSamePassword: typePinError !== 5,
                    },
                    () => {
                        recordEvent(
                            PATH_SELECT_CARD,
                            PAGE_PRODUCT,
                            'error tarjeta pin',
                            this.getCreatePinError(),
                            userProfile.recordId,
                            '',
                            '',
                            userProfile.investmentType,
                            docNumberEncrypted
                        );
                        // Auto remove the 'prospects-animation prospects-animation--shake' classes after 1 second or they wont trigger with subsequent errors
                        setTimeout(() => {
                            this.setState({ showShakeAnimationOnPasswordError: false });
                        }, 1000);
                    }
                );
            } else {
                this.setState({
                    passValid: valid,
                    showPassReq: !valid,
                    showShakeAnimationOnPasswordError: !valid,
                    passAscDesc: true,
                    passEquals: true,
                    passBirthYear: true,
                    passSamePassword: true,
                });
            }
        });
    }

    buildContentPinCard = () => {
        const { cardImages, userProfile } = this.props;
        const iconPass = `icons icons--${this.state.iconPass}`;
        const hiddenPasswordRequirements = classNames(
            'col-sm-12 md-form-group password-requirements card-selector-view__tooltip-input pin-card-requeriments',
            {
                'password-requirements--hidden': !this.state.showPassReq,
                'prospects-animation prospects-animation--shake': this.state.showShakeAnimationOnPasswordError,
            }
        );

        return (
            <div className="card-selector-view__content__cards">
                <p className="card-selector-view__content__cards__description">
                    <FormattedText value="initialPinCard-description" />
                </p>
                <div className="row">
                    <div className="col-md-7">
                        <h4>
                            <b>
                                <FormattedText value="initialPinCard-titleTypeCard" />
                            </b>
                        </h4>
                        <b className="card-selector-view__content__cards__title-input">
                            <FormattedText value="initialPinCard-titleInputPin" injectedStrings={['ed']} />
                        </b>
                        <div className="card-selector-view__content__cards__input">
                            <InputText
                                profileModel="userProfile.pinCard"
                                label={formatText('field-createPinCard')}
                                type={this.state.inputType}
                                isPassword
                                name="pinCard"
                                autoCompletePassword={false}
                                maxLength={4}
                                value={this.state.pinCard}
                                displayErrors={false}
                                placeholder={formatText('placeholder-password')}
                                onFocus={() => {
                                    this.handleShowPassReq(true);
                                }}
                                onChange={event => {
                                    if (event.target.value.length <= 4) {
                                        this.savePinCard(event.target.value);
                                    }
                                    if (event.target.value.length < 4) {
                                        this.handleAllValidators();
                                    }
                                    if (event.target.value.length === 0) {
                                        this.handleShowPassReq(false);
                                    } else if (event.target.value.length >= 4) {
                                        this.checkPassword(event.target.value);
                                        event.target.blur();
                                    }
                                }}
                                messagesError={{ required: formatText('validation-fieldRequired') }}
                                {...this.props}
                                tooltip={<InfoTooltip text={formatText('tooltip-pinCard')} />}
                            />
                            <i
                                className={iconPass}
                                onMouseEnter={() => this.handleIsOnEye()}
                                onMouseOut={() => this.handleIsOutEye()}
                                onClick={this.handlePassword}
                                onTouchStart={() => this.handleShowPassword()}
                                onTouchEnd={() => this.handleHidePassword()}
                            />
                        </div>
                        <div className="row">
                            <div className={hiddenPasswordRequirements}>
                                <h6 className="font-heading6">{formatText('field-Requirements')}</h6>
                                <ul>
                                    <li className={!this.state.passAscDesc ? 'requirement-fail' : undefined}>
                                        {formatText('field-passAscDesc')}
                                    </li>
                                    <li className={!this.state.passEquals ? 'requirement-fail' : undefined}>
                                        {formatText('field-passEquals')}
                                    </li>
                                    <li className={!this.state.passBirthYear ? 'requirement-fail' : undefined}>
                                        {formatText('field-passBirthYear')}
                                    </li>
                                    <li className={!this.state.passSamePassword ? 'requirement-fail' : undefined}>
                                        {formatText('field-passSamePassword')}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="card-selector-view__card-image">
                            <img
                                src={cardImages.get('cardURLImage')}
                                className="card-selector-view__content__cards__image"
                            />
                            <div className="card-selector-view__content__cards__image-description">
                                <p>
                                    <b>
                                        <FormattedText value="initialPinCard-titleNameCard" />
                                    </b>
                                </p>
                                <p className="card-selector-view__content__cards__image-description__name">{` ${userProfile.embossingName}`}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { passValid } = this.state;
        const headLine = this.buildHeadLine();
        const buildHeader = this.buildHeader();
        const buildContentPinCard = this.buildContentPinCard();

        return (
            <div className="pin-card-view">
                {buildHeader}
                <div className="pin-card-view__content">
                    {headLine}
                    {buildContentPinCard}
                </div>
                <div className="form__footer">
                    <RoadmapNavigation
                        buttonPrevHidden
                        buttonContinueType="submit"
                        buttonContinueDisabled={!passValid}
                        buttonContinueClass="form__button form__button-secondary"
                        buttonContinueAction={() => this.onHandleContinueButton()}
                        buttonPrevAction={() => this.backCardImageSelector()}
                    />
                </div>
            </div>
        );
    }
}

module.exports.constructor = PinCardView;
module.exports.PinCardView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        errorState: state.error,
        cardImages: state.cardImages,
    }),
    dispatch => ({
        stepsActions: bindActionCreators(stepsActions, dispatch),
        cardImagesActions: bindActionCreators(cardImagesActions, dispatch),
        debitCardActions: bindActionCreators(debitCardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        configCardActions: bindActionCreators(configCardActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(PinCardView);
